export { OptionsSheetBackdrop } from './lib/options_sheet_backdrop.component';
export { OptionsSheetHandle } from './lib/options_sheet_handle.component';
export { trapOptionsSheetTab } from './lib/trap_options_sheet_tab';
export { COMPACT_VIEWPORT_QUERY, useCompactViewport } from './lib/use_compact_viewport.hook';
export { useOptionsSheetPressGuard } from './lib/use_options_sheet_press_guard.hook';
/** Enter motion shared by the Select and Dropdown sheets. Reduced motion clears it in CSS, including while open. */
export const OPTIONS_SHEET_ENTER_CLASS = 'nucleus-animate-options-sheet-in motion-reduce:nucleus-animate-none';
//# sourceMappingURL=index.js.map